function convertToReal(value) {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value);
}

function getUFToProvince(uf) {
  var map = {
    'AC': 'Acre', 'AL': 'Alagoas', 'AM': 'Amazonas', 'AP': 'Amapá',
    'BA': 'Bahia', 'CE': 'Ceará', 'DF': 'Distrito Federal', 'ES': 'Espírito Santo',
    'GO': 'Goiás', 'MA': 'Maranhão', 'MG': 'Minas Gerais', 'MS': 'Mato Grosso do Sul',
    'MT': 'Mato Grosso', 'PA': 'Pará', 'PB': 'Paraíba', 'PE': 'Pernambuco', 'PI': 'Piauí',
    'PR': 'Paraná', 'RJ': 'Rio de Janeiro', 'RN': 'Rio Grande do Norte', 'RO': 'Rondônia',
    'RR': 'Roraima', 'RS': 'Rio Grande do Sul', 'SC': 'Santa Catarina', 'SE': 'Sergipe',
    'SP': 'São Paulo', 'TO': 'Tocantíns'
  };
  return map[uf] || '';
}

function renderRates(rates, container) {
  container.innerHTML = rates.length > 1
    ? '<p><strong>Existem ' + rates.length + ' tipos de fretes disponíveis.</strong></p>'
    : '<p><strong>Existe ' + rates.length + ' tipo de frete disponível.</strong></p>';
  rates.forEach(function(rate) {
    var li = document.createElement('li');
    var days = rate.delivery_days && rate.delivery_days[0];
    var printDays = days > 0 ? ' - ' + days + (days === 1 ? ' dia útil' : ' dias úteis') : '';
    var printPrice = rate.price > 0 ? convertToReal(rate.price) : 'Grátis';
    li.innerHTML = '<strong>' + rate.name + '</strong> - ' + printPrice + printDays;
    container.appendChild(li);
  });
}

const CustomShippingInit = async function(e) {
  var buttonEl = e.target;
  var parent = buttonEl.closest('.custom-shipping-calculator');
  var zipCode = (parent.querySelector('.custom_zip_code').value || '').replace(/\D/g, '');
  var country = 'Brazil';
  var province = '';

  if (zipCode.length !== 8) {
    alert('Digite um CEP válido (8 dígitos).');
    return;
  }

  parent.classList.add('loading');
  var ratesContainer = parent.querySelector('.shipping-rates');
  ratesContainer.innerHTML = '';

  try {
    var cepRes = await fetch('//viacep.com.br/ws/' + zipCode + '/json');
    var cepData = await cepRes.json();
    if (cepData.erro) {
      alert('CEP não encontrado. Verifique e tente novamente.');
      parent.classList.remove('loading');
      return;
    }
    province = getUFToProvince((cepData.uf || '').toUpperCase());
    if (!province) {
      alert('Indisponível no momento. Tente novamente mais tarde.');
      parent.classList.remove('loading');
      return;
    }

    var cartUrl = (typeof theme !== 'undefined' && theme.routes && theme.routes.cart) ? theme.routes.cart + '.js' : '/cart.js';
    var cartRes = await fetch(cartUrl);
    var cart = await cartRes.json();
    var cartWasEmpty = cart.item_count === 0;
    var addedLineKey = null;

    if (cartWasEmpty) {
      var idInput = (parent.closest('.product-info') && parent.closest('.product-info').querySelector('input[name="id"]')) ||
        document.querySelector('.js-product input[name="id"], .product-info input[name="id"]');
      var variantId = idInput ? (idInput.value || '').trim() : '';
      if (!variantId) {
        alert('Para simular o frete com o carrinho vazio, use o cálculo de frete na página do produto.');
        parent.classList.remove('loading');
        return;
      }

      var addUrl = (typeof theme !== 'undefined' && theme.routes && theme.routes.cartAdd) ? theme.routes.cartAdd : '/cart/add.js';
      var addRes = await fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      });
      var addData = await addRes.json();
      if (addData.status && addData.status !== 200 && addData.status !== 201) {
        var msg = addData.description || addData.message || 'Não foi possível adicionar o produto para simular o frete.';
        alert(msg);
        parent.classList.remove('loading');
        return;
      }
      if (addData.item && addData.item.key) {
        addedLineKey = addData.item.key;
      } else if (addData.items && addData.items.length) {
        var added = addData.items.find(function(item) { return String(item.variant_id) === String(variantId); });
        if (added) addedLineKey = added.key;
      }
      if (!addedLineKey) {
        var cartAfterRes = await fetch(cartUrl);
        var cartAfter = await cartAfterRes.json();
        var line = cartAfter.items && cartAfter.items.find(function(item) { return String(item.variant_id) === String(variantId); });
        if (line) addedLineKey = line.key;
      }
    }

    var shipRes = await fetch('/cart/shipping_rates.json?shipping_address[zip]=' + encodeURIComponent(zipCode) + '&shipping_address[country]=' + encodeURIComponent(country) + '&shipping_address[province]=' + encodeURIComponent(province));
    var shipData = await shipRes.json();
    var rates = (shipData && shipData.shipping_rates) ? shipData.shipping_rates : [];

    if (cartWasEmpty && addedLineKey) {
      var changeUrl = (typeof theme !== 'undefined' && theme.routes && theme.routes.cartChange) ? theme.routes.cartChange : '/cart/change.js';
      await fetch(changeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: addedLineKey, quantity: 0 })
      });
    }

    if (rates.length) {
      renderRates(rates, ratesContainer);
    } else {
      ratesContainer.innerHTML = '<p>Nenhuma opção de frete encontrada para este CEP.</p>';
    }
  } catch (err) {
    console.error('Erro ao calcular frete:', err);
    ratesContainer.innerHTML = '<p>Erro ao calcular frete. Tente novamente.</p>';
  }

  parent.classList.remove('loading');
};
